import { z } from "zod";
/** Callable `requestDeposit` (dashboard, owner/admin/pa). */
export const requestDepositRequestSchema = z.object({
    leadId: z.string().min(1).max(64),
    /** Minor units: at least 1.00. */
    amount: z.number().int().min(100).max(1_000_000),
    appointmentId: z.string().min(1).max(64).optional(),
    description: z.string().trim().max(200).optional(),
    channel: z.enum(["whatsapp", "email"]),
});
/** Callable `cancelDeposit` / `refundDeposit`. */
export const depositActionRequestSchema = z.object({ requestId: z.string().min(1).max(64) });
//# sourceMappingURL=deposit.js.map